export default object => {
  return Object.keys(object).reduce((string, key, i) => {
    const delimiter = i === 0 ? "?" : "&";
    let value = object[key];

    if (!value) {
      return string;
    }

    key = encodeURIComponent(key);
    if (Array.isArray(value)) {
      value = JSON.stringify(value);
    } else {
      value = encodeURIComponent(value);
    }

    return [string, delimiter, key, "=", value].join("");
  }, "");
};
